import { render, staticRenderFns } from "./ProdutoAssociarAgrupadores.vue?vue&type=template&id=a8ff1d32&"
import script from "./ProdutoAssociarAgrupadores.vue?vue&type=script&lang=js&"
export * from "./ProdutoAssociarAgrupadores.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoAssociarAgrupadores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports